import React from "react";
import { Button, Card } from "react-bootstrap";
import { useHistory } from "react-router-dom";

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

export default function SocialTile(props) {
  const history = useHistory();

  const goToSocial = () => {
    history.push(`${props.social.platform}/${props.social.handle}`);
  };
  return (
    <Card
      style={{
        backgroundColor: "#d3d3d3",
        height: 300,
        padding: 6,
        textAlign: "center",
      }}
    >
      <h4>
        <u>{props.social.platform.capitalize()}</u>
      </h4>
      <h4>@{props.social.handle}</h4>
      <h5>Status: {props.social.status}</h5>
      {props.social.status != "claimed" && (
        <i>
          DM us @andrew__burns on {props.social.platform} to verify you own this
        </i>
      )}
      <br></br>
      <br></br>
      <Button onClick={goToSocial}>View Page</Button>
    </Card>
  );
}
